export type TContactUsFormInputs = {
    feedbackType: string;
    subject: string;
    message: string;
    files: FileList | null;
}

export enum EFeedbackType {
    Error = 'Error',
    Feature = 'Feature',
    Improvement = 'Improvement',
    Other = 'Other'
}